module.exports = __webpack_public_path__ + "assets/img/18_171.daee0722.jpg";